<p class="competing-status muted" *ngIf="loading">Loading competing pages…</p>
<p class="competing-status muted" *ngIf="!loading && failed">Could not load the competing pages for this domain.</p>

<ng-container *ngIf="list">
  <p class="competing-headline">{{ list.headline }}</p>
  <!-- Where every number below comes from (cannibalizationEvidenceSourceLine): the Search Console
       window, or, without Search Console, the warning that they are estimates. -->
  <p class="competing-source muted" *ngIf="list.rows.length">{{ list.evidenceSourceLine }}</p>

  <div class="card competing-frame" *ngIf="list.rows.length">
    <table class="table">
      <thead>
        <tr>
          <th scope="col">Pages and verdict</th>
          <th scope="col">Shared searches</th>
        </tr>
      </thead>
      <tbody>
        <tr class="table__row competing-row" *ngFor="let row of list.rows; trackBy: trackRow">
          <td class="competing-pair">
            <span
              class="badge badge--caps competing-verdict"
              [ngClass]="row.verdict === 'merge' ? 'badge--danger' : 'badge--muted'"
              >{{ row.verdictLabel }}</span
            >
            <p class="competing-summary">{{ row.summary }}</p>
            <ul class="competing-pages-list">
              <li>
                <a class="competing-path" [routerLink]="detailLink(row.first.url)" [title]="row.first.url">{{ row.first.path }}</a>
              </li>
              <li>
                <a class="competing-path" [routerLink]="detailLink(row.second.url)" [title]="row.second.url">{{ row.second.path }}</a>
              </li>
            </ul>
          </td>
          <td class="competing-searches">
            <table class="table table--dense" *ngIf="row.searches.length">
              <thead>
                <tr>
                  <th scope="col">Search</th>
                  <th scope="col" class="competing-path">{{ row.first.path }}</th>
                  <th scope="col" class="competing-path">{{ row.second.path }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let s of row.searches">
                  <td>{{ s.search }}</td>
                  <td class="competing-number">{{ s.first }}</td>
                  <td class="competing-number">{{ s.second }}</td>
                </tr>
              </tbody>
            </table>
            <p class="competing-searches-line muted">{{ row.searchesLine }}</p>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</ng-container>
